import { render } from "./ImprestApproval.vue?vue&type=template&id=484b9636&scoped=true"
import script from "./ImprestApproval.vue?vue&type=script&lang=js"
export * from "./ImprestApproval.vue?vue&type=script&lang=js"

import "./ImprestApproval.vue?vue&type=style&index=0&id=484b9636&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-484b9636"]])

export default __exports__